import { motion, useScroll, useSpring, useTransform } from "framer-motion";
import { useRef } from "react";
import { experiences } from "../data/experience";
import ExperienceItem from "../components/experience/ExperienceItem";

const getYear = (timeframe: string): string => {
  const parts = timeframe.split("-")[0].trim();
  const yearMatch = parts.match(/\d{4}/);
  return yearMatch ? yearMatch[0] : parts;
};

const Experience = () => {
  const containerRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"],
  });

  const lineScale = useSpring(useTransform(scrollYProgress, [0, 1], [0, 1]), {
    stiffness: 100,
    damping: 30,
  });

  let lastRenderedYear: string | null = null;

  return (
    <section className="page-shell max-w-5xl">
      <h2 className="section-title mb-16 text-center text-4xl font-bold md:text-5xl">
        Experience
      </h2>

      {/* Single Continuous Timeline Line */}
      <motion.div
        style={{ scaleY: lineScale, transformOrigin: "top" }}
        className="absolute top-0 left-[42px] md:left-[58px] w-1 h-full rounded-full z-0 bg-[linear-gradient(180deg,var(--primary),var(--accent))]"
      />

      <div ref={containerRef} className="space-y-28 relative z-10">
        {experiences.map((exp, i) => {
          const year = getYear(exp.timeframe);
          const isNewYear = year !== lastRenderedYear;
          lastRenderedYear = year;

          return (
            <div
              key={i}
              className={`relative ${i === 0 ? "mt-16 md:mt-0" : ""}`}
            >
              {isNewYear && (
                <motion.div
                  initial={{ opacity: 0, y: 40 }}
                  animate={i === 0 ? { opacity: 1, y: 0 } : undefined}
                  whileInView={i !== 0 ? { opacity: 1, y: 0 } : undefined}
                  transition={{ duration: 0.5 }}
                  className="pointer-events-none absolute -top-16 left-1/2 -translate-x-1/2 text-5xl font-black text-[color:var(--text-soft)] opacity-60 md:text-6xl"
                >
                  {year}
                </motion.div>
              )}

              <ExperienceItem exp={exp} forceAnimate={i === 0} />
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Experience;
